{
  "HELP_CENTER": {
    "TITLE": "Help Center",
    "NEW_PAGE": {
      "DESCRIPTION": "Create self-service help center portals for your customers. Help them find answers quickly, without waiting. Streamline inquiries, boost agent efficiency, and elevate customer support.",
      "CREATE_PORTAL_BUTTON": "Create Portal"
    },
    "HEADER": {
      "FILTER": "Filter by",
      "SORT": "Sort by",
      "LOCALE": "Locale",
      "SETTINGS_BUTTON": "Stillingar",
      "NEW_BUTTON": "New Article",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Published",
        "DRAFT": "Draft",
        "ARCHIVED": "Archived"
      },
      "TITLES": {
        "ALL_ARTICLES": "All Articles",
        "MINE": "My Articles",
        "DRAFT": "Draft Articles",
        "ARCHIVED": "Archived Articles"
      },
      "LOCALE_SELECT": {
        "TITLE": "Select locale",
        "PLACEHOLDER": "Select locale",
        "NO_RESULT": "No locale found",
        "SEARCH_PLACEHOLDER": "Search locale"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "All Articles",
      "PUBLISH_BUTTON": "Publish",
      "MOVE_TO_ARCHIVE_BUTTON": "Move to archived",
      "PREVIEW": "Preview",
      "ADD_TRANSLATION": "Add translation",
      "OPEN_SIDEBAR": "Open sidebar",
      "CLOSE_SIDEBAR": "Close sidebar",
      "SAVING": "Saving...",
      "SAVED": "Saved"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Hlaða upp mynd",
        "UPLOADING": "Hleður upp...",
        "SUCCESS": "Image uploaded successfully",
        "ERROR": "Error while uploading image",
        "UN_AUTHORIZED_ERROR": "You are not authorized to upload images",
        "ERROR_FILE_SIZE": "Image size should be less than {size}MB",
        "ERROR_FILE_FORMAT": "Image format should be jpg, jpeg or png",
        "ERROR_FILE_DIMENSIONS": "Image dimensions should be less than 2000 x 2000"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Article Settings",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Category",
          "TITLE": "Select category",
          "PLACEHOLDER": "Select category",
          "NO_RESULT": "No category found",
          "SEARCH_PLACEHOLDER": "Search category"
        },
        "AUTHOR": {
          "LABEL": "Author",
          "TITLE": "Select author",
          "PLACEHOLDER": "Select author",
          "NO_RESULT": "No authors found",
          "SEARCH_PLACEHOLDER": "Search author"
        },
        "META_TITLE": {
          "LABEL": "Meta title",
          "PLACEHOLDER": "Add a meta title"
        },
        "META_DESCRIPTION": {
          "LABEL": "Meta description",
          "PLACEHOLDER": "Bættu við meta lýsingu til að fá betri niðurstöður í leitarvélarbestun..."
        },
        "META_TAGS": {
          "LABEL": "Meta tags",
          "PLACEHOLDER": "Add meta tags separated by comma..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Archive article",
        "DELETE": "Delete article"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Uncategorized",
      "SEARCH_RESULTS": "Search results for {query}",
      "EMPTY_TEXT": "Search for articles to insert into replies.",
      "SEARCH_LOADER": "Searching...",
      "INSERT_ARTICLE": "Insert",
      "NO_RESULT": "No articles found",
      "COPY_LINK": "Copy article link to clipboard",
      "OPEN_LINK": "Open article in new tab",
      "PREVIEW_LINK": "Preview article"
    },
    "PORTAL": {
      "HEADER": "Portals",
      "DEFAULT": "Default",
      "NEW_BUTTON": "New Portal",
      "ACTIVE_BADGE": "active",
      "CHOOSE_LOCALE_LABEL": "Choose a locale",
      "LOADING_MESSAGE": "Loading portals...",
      "ARTICLES_LABEL": "articles",
      "NO_PORTALS_MESSAGE": "There are no available portals",
      "ADD_NEW_LOCALE": "Add a new locale",
      "POPOVER": {
        "TITLE": "Portals",
        "PORTAL_SETTINGS": "Portal settings",
        "SUBTITLE": "Þú ert með margar gáttir og getur haft mismunandi landastaðla fyrir hverja gátt.",
        "CANCEL_BUTTON_LABEL": "Hætta við",
        "CHOOSE_LOCALE_BUTTON": "Choose Locale"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "articles",
            "ADD": "Add locale",
            "VISIT": "Visit site",
            "SETTINGS": "Stillingar",
            "DELETE": "Eyða"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Portal Configurations",
            "ITEMS": {
              "NAME": "Nafn",
              "DOMAIN": "Custom domain",
              "SLUG": "Slug",
              "TITLE": "Portal title",
              "THEME": "Theme color",
              "SUB_TEXT": "Portal sub text"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Available locales",
            "TABLE": {
              "NAME": "Locale name",
              "CODE": "Locale code",
              "ARTICLE_COUNT": "No. of articles",
              "CATEGORIES": "No. of categories",
              "SWAP": "Swap",
              "DELETE": "Eyða",
              "DEFAULT_LOCALE": "Default"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Delete portal",
          "MESSAGE": "Ertu viss um að þú viljir eyða þessari gátt",
          "YES": "Yes, delete portal",
          "NO": "No, keep portal",
          "API": {
            "DELETE_SUCCESS": "Portal deleted successfully",
            "DELETE_ERROR": "Error while deleting portal"
          }
        },
        "SEND_CNAME_INSTRUCTIONS": {
          "API": {
            "SUCCESS_MESSAGE": "CNAME instructions sent successfully",
            "ERROR_MESSAGE": "Error while sending CNAME instructions"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Edit portal",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Basic information"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Portal customization"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Categories"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Locales"
          }
        },
        "CATEGORIES": {
          "TITLE": "Categories in",
          "NEW_CATEGORY": "New category",
          "TABLE": {
            "NAME": "Nafn",
            "DESCRIPTION": "Description",
            "LOCALE": "Locale",
            "ARTICLE_COUNT": "No. of articles",
            "ACTION_BUTTON": {
              "EDIT": "Edit category",
              "DELETE": "Delete category"
            },
            "EMPTY_TEXT": "No categories found"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Update basic settings"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Help center information",
            "BODY": "Basic information about portal"
          },
          "CUSTOMIZATION": {
            "TITLE": "Help center customization",
            "BODY": "Customize portal"
          },
          "FINISH": {
            "TITLE": "Voila! 🎉",
            "BODY": "You're all set!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Til baka",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Create Portal",
            "TITLE": "Help center information",
            "CREATE_BASIC_SETTING_BUTTON": "Create portal basic settings"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Portal customisation",
            "TITLE": "Help center customization",
            "UPDATE_PORTAL_BUTTON": "Update portal settings"
          },
          "FINISH_PAGE": {
            "TITLE": "Voila!🎉 You're all set up!",
            "MESSAGE": "Þú getur nú séð þessa stofnuðu gátt á síðunni þinni fyrir allar gáttir.",
            "FINISH": "Go to all portals page"
          }
        },
        "LOGO": {
          "LABEL": "Logo",
          "UPLOAD_BUTTON": "Upload logo",
          "HELP_TEXT": "Þetta lógó mun birtast á haus gáttarinnar.",
          "IMAGE_UPLOAD_SUCCESS": "Logo uploaded successfully",
          "IMAGE_UPLOAD_ERROR": "Logo deleted successfully",
          "IMAGE_DELETE_ERROR": "Error while deleting logo"
        },
        "NAME": {
          "LABEL": "Nafn",
          "PLACEHOLDER": "Portal name",
          "HELP_TEXT": "Nafnið verður notað í almannagáttinni innbyrðis.",
          "ERROR": "Name is required"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portal slug for urls",
          "ERROR": "Slug is required"
        },
        "DOMAIN": {
          "LABEL": "Custom Domain",
          "PLACEHOLDER": "Portal custom domain",
          "HELP_TEXT": "Add only If you want to use a custom domain for your portals. Eg: {exampleURL}",
          "ERROR": "Enter a valid domain URL"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Home Page Link",
          "PLACEHOLDER": "Portal home page link",
          "HELP_TEXT": "The link used to return from the portal to the home page. Eg: {exampleURL}",
          "ERROR": "Enter a valid home page URL"
        },
        "THEME_COLOR": {
          "LABEL": "Portal theme color",
          "HELP_TEXT": "Þessi litur mun birtast sem þemalitur gáttarinnar."
        },
        "PAGE_TITLE": {
          "LABEL": "Page Title",
          "PLACEHOLDER": "Portal page title",
          "HELP_TEXT": "Titill síðunnar verður notaður í gáttinni sem snýr að almenningi.",
          "ERROR": "Page title is required"
        },
        "HEADER_TEXT": {
          "LABEL": "Header Text",
          "PLACEHOLDER": "Portal header text",
          "HELP_TEXT": "Texti gáttarhaussins verður notaður í gáttinni sem snýr að almenningi.",
          "ERROR": "Portal header text is required"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portal created successfully.",
          "ERROR_MESSAGE_FOR_BASIC": "Couldn't create the portal. Try again.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portal updated successfully.",
          "ERROR_MESSAGE_FOR_UPDATE": "Couldn't update the portal. Try again."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Add a new locale",
        "SUB_TITLE": "Þetta bætir nýjum landstaðli við tiltæka þýðingarlistann þinn.",
        "PORTAL": "Portal",
        "LOCALE": {
          "LABEL": "Locale",
          "PLACEHOLDER": "Choose a locale",
          "ERROR": "Locale is required"
        },
        "BUTTONS": {
          "CREATE": "Create locale",
          "CANCEL": "Hætta við"
        },
        "API": {
          "SUCCESS_MESSAGE": "Locale added successfully",
          "ERROR_MESSAGE": "Unable to add locale. Try again."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Default locale updated successfully",
          "ERROR_MESSAGE": "Ekki er hægt að uppfæra sjálfgefna landstaðal. Reyndu aftur."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Locale removed from portal successfully",
          "ERROR_MESSAGE": "Ekki tókst að fjarlægja landstaðli úr gáttinni. Reyndu aftur."
        }
      },
      "DRAFT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Locale moved to draft successfully",
          "ERROR_MESSAGE": "Unable to move locale to draft. Try again."
        }
      },
      "PUBLISH_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Locale published successfully",
          "ERROR_MESSAGE": "Unable to publish locale. Try again."
        }
      }
    },
    "TABLE": {
      "LOADING_MESSAGE": "Loading articles...",
      "404": "No articles matches your search 🔍",
      "NO_ARTICLES": "There are no available articles",
      "HEADERS": {
        "TITLE": "Title",
        "CATEGORY": "Category",
        "READ_COUNT": "Views",
        "STATUS": "Staða",
        "LAST_EDITED": "Last edited"
      },
      "COLUMNS": {
        "BY": "by",
        "AUTHOR_NOT_AVAILABLE": "Author is not available"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Loading article...",
      "TITLE_PLACEHOLDER": "Article title goes here",
      "CONTENT_PLACEHOLDER": "Write your article here",
      "API": {
        "ERROR": "Error while saving article"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Error while publishing article",
        "SUCCESS": "Article published successfully"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Error while archiving article",
        "SUCCESS": "Article archived successfully"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Error while drafting article",
        "SUCCESS": "Article drafted successfully"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Staðfesta eyðingu",
          "MESSAGE": "Are you sure to delete the article?",
          "YES": "Yes, Delete",
          "NO": "No, Keep it"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Article deleted successfully",
        "ERROR_MESSAGE": "Error while deleting article"
      }
    },
    "REORDER_ARTICLE": {
      "API": {
        "ERROR_MESSAGE": "Unable to reorder articles. Please try again."
      }
    },
    "REORDER_CATEGORY": {
      "API": {
        "ERROR_MESSAGE": "Unable to reorder categories. Please try again."
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Vinsamlegast bættu við fyrirsögn greinarinnar og innihaldi þá er aðeins þú sem getur uppfært stillingarnar"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Search for articles"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Create a category",
        "SUB_TITLE": "Flokkurinn verður notað í gáttinni sem snýr að almenningi til að flokka greinar.",
        "PORTAL": "Portal",
        "LOCALE": "Locale",
        "NAME": {
          "LABEL": "Nafn",
          "PLACEHOLDER": "Category name",
          "HELP_TEXT": "The category name and icon will be used in the public facing portal to categorize articles.",
          "ERROR": "Name is required"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Category slug for urls",
          "HELP_TEXT": "app.chatwoot.com/hc/my-portal/en-US/categories/slodin-min",
          "ERROR": "Slug is required"
        },
        "DESCRIPTION": {
          "LABEL": "Description",
          "PLACEHOLDER": "Gefðu stutta lýsingu á flokknum.",
          "ERROR": "Description is required"
        },
        "BUTTONS": {
          "CREATE": "Create category",
          "CANCEL": "Hætta við"
        },
        "API": {
          "SUCCESS_MESSAGE": "Category created successfully",
          "ERROR_MESSAGE": "Unable to create category"
        }
      },
      "EDIT": {
        "TITLE": "Edit a category",
        "SUB_TITLE": "Breyting á flokki mun uppfæra flokkinn í opinberu gáttinni.",
        "PORTAL": "Portal",
        "LOCALE": "Locale",
        "NAME": {
          "LABEL": "Nafn",
          "PLACEHOLDER": "Category name",
          "HELP_TEXT": "The category name and icon will be used in the public facing portal to categorize articles.",
          "ERROR": "Name is required"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Category slug for urls",
          "HELP_TEXT": "app.chatwoot.com/hc/my-portal/en-US/categories/slodin-min",
          "ERROR": "Slug is required"
        },
        "DESCRIPTION": {
          "LABEL": "Description",
          "PLACEHOLDER": "Gefðu stutta lýsingu á flokknum.",
          "ERROR": "Description is required"
        },
        "BUTTONS": {
          "CREATE": "Update category",
          "CANCEL": "Hætta við"
        },
        "API": {
          "SUCCESS_MESSAGE": "Category updated successfully",
          "ERROR_MESSAGE": "Unable to update category"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Category deleted successfully",
          "ERROR_MESSAGE": "Unable to delete category"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Search articles",
      "PLACEHOLDER": "Search articles",
      "NO_RESULT": "No articles found",
      "SEARCHING": "Searching...",
      "SEARCH_BUTTON": "Leit",
      "INSERT_ARTICLE": "Insert link",
      "IFRAME_ERROR": "URL is empty or invalid. Unable to display content.",
      "OPEN_ARTICLE_SEARCH": "Insert article from Help Center",
      "SUCCESS_ARTICLE_INSERTED": "Article inserted successfully",
      "PREVIEW_LINK": "Preview article",
      "CANCEL": "Loka",
      "BACK": "Til baka",
      "BACK_RESULTS": "Back to results"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Help Center",
      "DESCRIPTION": "Create user-friendly self-service portals. Help your users to access the articles and get support 24/7. Upgrade your subscription to enable this feature.",
      "SELF_HOSTED_DESCRIPTION": "Create user-friendly self-service portals. Help your users to access the articles and get support 24/7. Please contact your administrator to enable this feature.",
      "BUTTON": {
        "LEARN_MORE": "Læra meira",
        "UPGRADE": "Upgrade"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Multiple portals",
          "DESCRIPTION": "Create multiple help center portals for different products using the same account."
        },
        "LOCALES": {
          "TITLE": "Full support for locales",
          "DESCRIPTION": "Localize the portal in your language. We support all locales and allow translations for every article."
        },
        "SEO": {
          "TITLE": "SEO-friendly design",
          "DESCRIPTION": "Customize your meta tags to improve your visibility on search engines with our SEO-friendly pages."
        },
        "API": {
          "TITLE": "Full API support",
          "DESCRIPTION": "Use the portal as a headless CMS with third party front-end frameworks using our APIs."
        }
      }
    },
    "LOADING": "Loading...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} view | {count} views",
          "DROPDOWN_MENU": {
            "PUBLISH": "Publish",
            "DRAFT": "Draft",
            "ARCHIVE": "Archive",
            "TRANSLATE": "Translate",
            "DELETE": "Eyða"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "Published",
            "ARCHIVED": "Archived"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Uncategorised"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "All articles",
          "MINE": "Mitt",
          "DRAFT": "Draft",
          "PUBLISHED": "Published",
          "ARCHIVED": "Archived"
        },
        "CATEGORY": {
          "ALL": "All categories"
        },
        "LOCALE": {
          "ALL": "All locales"
        },
        "NEW_ARTICLE": "New article"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Write an article",
          "SUBTITLE": "Write a rich article, let’s get started!",
          "BUTTON_LABEL": "New article"
        },
        "MINE": {
          "TITLE": "You haven't written any articles here",
          "SUBTITLE": "All articles written by you show up here for quick access."
        },
        "DRAFT": {
          "TITLE": "There are no articles in drafts",
          "SUBTITLE": "Draft articles will appear here"
        },
        "PUBLISHED": {
          "TITLE": "There are no published articles",
          "SUBTITLE": "Published articles will appear here"
        },
        "ARCHIVED": {
          "TITLE": "There are no articles in the archive",
          "SUBTITLE": "Archived articles don't show up on the portal, you can use it to mark deprecated or outdated pages"
        },
        "CATEGORY": {
          "TITLE": "There are no articles in this category",
          "SUBTITLE": "Articles in this category will appear here"
        }
      },
      "BULK_TRANSLATE": {
        "TITLE": "Translate article | Translate {count} articles",
        "DESCRIPTION": "Translate the selected article to another language. | Translate the selected articles to another language.",
        "LOCALE_LABEL": "Target language",
        "LOCALE_PLACEHOLDER": "Select a language",
        "CATEGORY_LABEL": "Target category",
        "CATEGORY_PLACEHOLDER": "Select a category",
        "OPTIONAL": "(optional)",
        "CONFIRM": "Translate",
        "SELECT_ALL": "Select all ({count})",
        "SELECTED_COUNT": "{count} selected",
        "CLEAR_SELECTION": "Clear selection",
        "TRANSLATE_BUTTON": "Translate",
        "CONFIRM_OVERWRITE": "Overwrite and translate",
        "DUPLICATE_WARNING": "A translation already exists for this article in the selected language. | Translations already exist for {count} articles in the selected language.",
        "DUPLICATE_CONFIRM_HINT": "Click translate again to overwrite the existing translation.",
        "API": {
          "SUCCESS_MESSAGE": "Translation in progress. The article will appear as a draft once ready.",
          "ERROR_MESSAGE": "Failed to start translation. Please try again."
        }
      },
      "BULK_ACTIONS": {
        "PUBLISH": "Publish",
        "DRAFT": "Draft",
        "ARCHIVE": "Archive",
        "TRANSLATE": "Translate",
        "MOVE_TO_CATEGORY": "Category",
        "DELETE": "Eyða",
        "STATUS_SUCCESS": "Articles updated successfully",
        "STATUS_ERROR": "Failed to update articles",
        "CATEGORY_SUCCESS": "Articles moved successfully",
        "CATEGORY_ERROR": "Failed to move articles",
        "DELETE_CONFIRM_TITLE": "Delete article | Delete {count} articles",
        "DELETE_CONFIRM_DESCRIPTION": "This will permanently delete the selected article. This action cannot be undone. | This will permanently delete {count} selected articles. This action cannot be undone.",
        "DELETE_CONFIRM": "Eyða",
        "DELETE_SUCCESS": "Articles deleted successfully",
        "DELETE_ERROR": "Failed to delete articles"
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "New category",
        "EDIT_CATEGORY": "Edit category",
        "CATEGORIES_COUNT": "{n} category | {n} categories",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Categories ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} articles) | {categoryName} ({categoryCount} article)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "No categories found",
        "SUBTITLE": "Categories will appear here. You can add a category by clicking the 'New Category' button."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} article | {count} articles"
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Category created successfully",
            "ERROR_MESSAGE": "Unable to create category"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Category updated successfully",
            "ERROR_MESSAGE": "Unable to update category"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Category deleted successfully",
            "ERROR_MESSAGE": "Unable to delete category"
          }
        },
        "HEADER": {
          "CREATE": "Create category",
          "EDIT": "Edit category",
          "DESCRIPTION": "Breyting á flokki mun uppfæra flokkinn í opinberu gáttinni.",
          "PORTAL": "Portal",
          "LOCALE": "Locale"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Nafn",
            "PLACEHOLDER": "Category name",
            "ERROR": "Name is required"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Category slug for urls",
            "ERROR": "Slug is required",
            "HELP_TEXT": "app.chatwoot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Description",
            "PLACEHOLDER": "Gefðu stutta lýsingu á flokknum.",
            "ERROR": "Description is required"
          }
        },
        "BUTTONS": {
          "CREATE": "Stofna",
          "EDIT": "Uppfæra",
          "CANCEL": "Hætta við"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "No locales available | {n} locale | {n} locales",
      "NEW_LOCALE_BUTTON_TEXT": "New locale",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} article | {count} articles",
        "CATEGORIES_COUNT": "{count} category | {count} categories",
        "DEFAULT": "Default",
        "DRAFT": "Draft",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Make default",
          "MOVE_TO_DRAFT": "Move to draft",
          "PUBLISH_LOCALE": "Publish locale",
          "DELETE": "Eyða"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Add a new locale",
        "DESCRIPTION": "Select the language in which this article will be written. This will be added to your list of translations, and you can add more later.",
        "COMBOBOX": {
          "PLACEHOLDER": "Select locale..."
        },
        "STATUS": {
          "LABEL": "Staða",
          "OPTIONS": {
            "LIVE": "Published",
            "DRAFT": "Draft"
          }
        },
        "API": {
          "SUCCESS_MESSAGE": "Locale added successfully",
          "ERROR_MESSAGE": "Unable to add locale. Try again."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Saving...",
          "SAVED": "Saved"
        },
        "PREVIEW": "Preview",
        "PUBLISH": "Publish",
        "DRAFT": "Draft",
        "ARCHIVE": "Archive",
        "BACK_TO_ARTICLES": "Back to articles"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "More properties",
        "UNCATEGORIZED": "Uncategorized",
        "EDITOR_PLACEHOLDER": "Write your content here. Type '/' for formatting options."
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Article properties",
        "META_DESCRIPTION": "Meta description",
        "META_DESCRIPTION_PLACEHOLDER": "Add meta description",
        "META_TITLE": "Meta title",
        "META_TITLE_PLACEHOLDER": "Add meta title",
        "META_TAGS": "Meta tags",
        "META_TAGS_PLACEHOLDER": "Add meta tags"
      },
      "API": {
        "ERROR": "Error while saving article"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "New portal",
      "PORTALS": "Portals",
      "CREATE_PORTAL": "Create and manage multiple portals",
      "ARTICLES": "articles",
      "DOMAIN": "lén",
      "PORTAL_NAME": "Portal name"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Create new portal",
      "DESCRIPTION": "Give your portal a name and create a user-friendly URL slug. You can modify both later in the settings.",
      "CONFIRM_BUTTON_LABEL": "Stofna",
      "NAME": {
        "LABEL": "Nafn",
        "PLACEHOLDER": "User Guide | Chatwoot",
        "MESSAGE": "Choose an name for your portal.",
        "ERROR": "Name is required"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Slug is required",
        "FORMAT_ERROR": "Please enter a valid slug, for eg: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logo",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the logo",
          "IMAGE_DELETE_SUCCESS": "Logo deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete logo",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "NAME": {
          "LABEL": "Nafn",
          "PLACEHOLDER": "Portal name",
          "ERROR": "Name is required"
        },
        "HEADER_TEXT": {
          "LABEL": "Header text",
          "PLACEHOLDER": "Portal header text"
        },
        "PAGE_TITLE": {
          "LABEL": "Page title",
          "PLACEHOLDER": "Portal page title"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Home page link",
          "PLACEHOLDER": "Portal home page link",
          "ERROR": "Enter a valid URL. The Home page link must start with 'http://' or 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portal slug"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Live chat widget",
          "PLACEHOLDER": "Select live chat widget",
          "HELP_TEXT": "Select a live chat widget that will appear on your help center",
          "NONE_OPTION": "No widget"
        },
        "BRAND_COLOR": {
          "LABEL": "Brand color"
        },
        "SAVE_CHANGES": "Save changes"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Custom domain",
          "LABEL": "Custom domain:",
          "DESCRIPTION": "You can host your portal on a custom domain. For instance, if your website is yourdomain.com and you want your portal available at docs.yourdomain.com, simply enter that in this field.",
          "STATUS_DESCRIPTION": "Your custom portal will start working as soon as it is verified.",
          "PLACEHOLDER": "Portal custom domain",
          "EDIT_BUTTON": "Breyta",
          "ADD_BUTTON": "Add custom domain",
          "STATUS": {
            "LIVE": "Live",
            "PENDING": "Awaiting verification",
            "ERROR": "Verification failed"
          },
          "DIALOG": {
            "ADD_HEADER": "Add custom domain",
            "EDIT_HEADER": "Edit custom domain",
            "ADD_CONFIRM_BUTTON_LABEL": "Add domain",
            "EDIT_CONFIRM_BUTTON_LABEL": "Update domain",
            "LABEL": "Custom domain",
            "PLACEHOLDER": "Portal custom domain",
            "ERROR": "Custom domain is required",
            "FORMAT_ERROR": "Please enter a valid domain URL e.g. docs.yourdomain.com"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "DNS configuration",
            "DESCRIPTION": "Log in to the account you have with your DNS provider, and add a CNAME record for subdomain pointing to chatwoot.help",
            "COPY": "Successfully copied CNAME",
            "SEND_INSTRUCTIONS": {
              "HEADER": "Send instructions",
              "DESCRIPTION": "If you would prefer to have someone from your development team to handle this step, you can enter email address below, and we will send them the required instructions.",
              "PLACEHOLDER": "Enter their email",
              "ERROR": "Enter a valid email address",
              "SEND_BUTTON": "Send"
            }
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Delete {portalName}",
          "HEADER": "Delete portal",
          "DESCRIPTION": "Permanently delete this portal. This action is irreversible",
          "DIALOG": {
            "HEADER": "Sure you want to delete {portalName}?",
            "DESCRIPTION": "This is a permanent action that cannot be reversed.",
            "CONFIRM_BUTTON_LABEL": "Eyða"
          }
        },
        "EDIT_CONFIGURATION": "Edit configuration"
      },
      "LAYOUT_CONTENT": {
        "HEADER": "Appearance",
        "DESCRIPTION": "Pick the layout that fits how your visitors read.",
        "LAYOUT": {
          "CLASSIC": {
            "TITLE": "Classic",
            "DESCRIPTION": "A welcoming home page with search and featured topics."
          },
          "SIDEBAR": {
            "TITLE": "Documentation",
            "DESCRIPTION": "Side-by-side navigation that keeps every guide a click away."
          }
        },
        "SOCIAL_LINKS": {
          "HEADER": "Social links",
          "DESCRIPTION": "Add the handle for each network and your help center builds the full link. Shown in the documentation layout footer.",
          "PLACEHOLDER": "handle",
          "ADD": "Add social link",
          "REMOVE": "Fjarlægja"
        },
        "SAVE": "Save changes"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal created successfully",
          "ERROR_MESSAGE": "Unable to create portal"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal updated successfully",
          "ERROR_MESSAGE": "Unable to update portal"
        }
      }
    },
    "PDF_UPLOAD": {
      "TITLE": "Upload PDF Document",
      "DESCRIPTION": "Upload a PDF document to automatically generate FAQs using AI",
      "DRAG_DROP_TEXT": "Drag and drop your PDF file here, or click to select",
      "SELECT_FILE": "Select PDF File",
      "ADDITIONAL_CONTEXT_LABEL": "Additional Context (Optional)",
      "ADDITIONAL_CONTEXT_PLACEHOLDER": "Provide any additional context or instructions for FAQ generation...",
      "UPLOADING": "Hleður upp...",
      "UPLOAD": "Upload & Process",
      "CANCEL": "Hætta við",
      "ERROR_INVALID_TYPE": "Please select a valid PDF file",
      "ERROR_FILE_TOO_LARGE": "File size must be less than 512MB",
      "ERROR_UPLOAD_FAILED": "Failed to upload PDF. Please try again."
    },
    "PDF_DOCUMENTS": {
      "TITLE": "PDF Documents",
      "DESCRIPTION": "Manage uploaded PDF documents and generate FAQs from them",
      "UPLOAD_PDF": "Upload PDF",
      "UPLOAD_FIRST_PDF": "Upload your first PDF",
      "UPLOADED_BY": "Uploaded by",
      "GENERATE_FAQS": "Generate FAQs",
      "GENERATING": "Generating...",
      "CONFIRM_DELETE": "Are you sure you want to delete {filename}?",
      "EMPTY_STATE": {
        "TITLE": "No PDF documents yet",
        "DESCRIPTION": "Upload PDF documents to automatically generate FAQs using AI"
      },
      "STATUS": {
        "UPLOADED": "Ready",
        "PROCESSING": "Processing",
        "PROCESSED": "Completed",
        "FAILED": "Failed"
      }
    },
    "CONTENT_GENERATION": {
      "TITLE": "Content Generation",
      "DESCRIPTION": "Upload PDF documents to automatically generate FAQ content using AI",
      "UPLOAD_TITLE": "Upload PDF Document",
      "DRAG_DROP": "Drag and drop your PDF file here, or click to select",
      "SELECT_FILE": "Select PDF File",
      "UPLOADING": "Processing document...",
      "UPLOAD_SUCCESS": "Document processed successfully!",
      "UPLOAD_ERROR": "Failed to upload document. Please try again.",
      "INVALID_FILE_TYPE": "Please select a valid PDF file",
      "FILE_TOO_LARGE": "File size must be less than 512MB",
      "GENERATED_CONTENT": "Generated FAQ Content",
      "PUBLISH_SELECTED": "Publish Selected",
      "PUBLISHING": "Publishing...",
      "FROM_DOCUMENT": "From document",
      "NO_CONTENT": "No generated content available. Upload a PDF document to get started.",
      "LOADING": "Loading generated content..."
    }
  }
}
